/* Customer Reviews page — pulls every product's reviews from Judge.me's public
   widget endpoint and renders them in Three Oh Six design. Reihenfolge ist fest:
   erst die Produktbewertungen, nach Produkt geclustert, dann die
   Shop-Bewertungen. Gefiltert wird nach Kategorie (alle / Produkt / Shop) und
   nach Sternen. No Judge.me widget JS involved. */
(function () {
  var root = document.querySelector('[data-tos-crv]');
  if (!root) return;

  var cfgEl = document.getElementById('tos-crv-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var S = cfg.strings || {};
  // v3: der Cache haelt seit den Shop-Bewertungen nur noch die API-Daten. Alte
  // v2-Eintraege enthielten das komplette Set und wuerden hier doppelt zaehlen.
  var CACHE_KEY = 'tos-crv-cache-v3-' + (cfg.locale || 'x');
  var CACHE_MS = 10 * 60 * 1000;

  // Shop-Bewertungen kommen aus dem Liquid, nicht aus der API: Judge.me hat
  // keinen shop-weiten Endpoint. Sie werden bei jedem Load frisch eingebettet
  // und deshalb bewusst NICHT mitgecacht.
  var shopReviews = (cfg.shopReviews || []).map(function (r) {
    return {
      productId: null,
      isShop: true,
      rating: r.rating,
      title: (r.title || '').trim(),
      body: r.body || '',
      nameRaw: (r.nameRaw || '').trim(),
      isAnon: !!r.isAnon,
      date: r.date,
      verified: !!r.verified,
      pictures: r.pictures || [],
      reply: r.reply || '',
      replyName: r.replyName || cfg.shopName
    };
  });

  var state = {
    star: 'all',
    cat: 'all',
    sort: 'recent'
  };
  var reviews = [];

  /* ---------- helpers ---------- */
  function el(tag, props, kids) {
    var n = document.createElement(tag);
    if (props) Object.keys(props).forEach(function (k) {
      if (k === 'class') n.className = props[k];
      else if (k === 'text') n.textContent = props[k];
      else if (k === 'html') n.innerHTML = props[k]; // only ever used with our own markup
      else if (props[k] !== null && props[k] !== undefined) n.setAttribute(k, props[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }

  // Judge.me returns review bodies as HTML. Render them as plain text so no
  // markup from a review can ever execute on our page.
  function toText(html) {
    if (!html) return '';
    var withBreaks = String(html).replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n\n');
    var tmp = document.createElement('div');
    tmp.innerHTML = withBreaks;
    return (tmp.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
  }

  // Judge.me stores "Anonymous" as a literal name when the buyer left the field
  // empty — swap it for the localised label so the DE page never shows English.
  function displayName(r) {
    var raw = r.nameRaw || '';
    if (r.isAnon || !raw || /^anonymous$/i.test(raw) || /^anonym$/i.test(raw)) {
      return S.anonymous || 'Anonym';
    }
    return raw;
  }

  // Der abgerundete Stern des Shops. Zwilling von snippets/star-row.liquid —
  // wer den Pfad dort ändert, muss ihn hier mitziehen.
  var STAR_SVG = '<svg class="tos-star" viewBox="2.4 1.64 19.2 19.2" aria-hidden="true" focusable="false">'
    + '<path d="M12 4 L14.12 9.09 L19.61 9.53 L15.42 13.11 L16.7 18.47 L12 15.6 L7.3 18.47 L8.58 13.11 L4.39 9.53 L9.88 9.09 Z"'
    + ' fill="currentColor" stroke="currentColor" stroke-width="3.2" stroke-linejoin="round" stroke-linecap="round"/></svg>';

  function starSvg(n) {
    var out = '';
    for (var i = 0; i < n; i++) out += STAR_SVG;
    return out;
  }

  function stars(rating) {
    var full = Math.round(rating || 0);
    var wrap = el('span', { class: 'tos-crv__stars', 'aria-hidden': 'true' });
    if (full > 0) wrap.appendChild(el('span', { html: starSvg(full) }));
    if (full < 5) wrap.appendChild(el('span', { class: 'off', html: starSvg(5 - full) }));
    return wrap;
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d)) return '';
    try {
      return d.toLocaleDateString(cfg.locale === 'de' ? 'de-DE' : 'en-GB',
        { year: 'numeric', month: 'short', day: 'numeric' });
    } catch (e) { return d.toISOString().slice(0, 10); }
  }

  /* ---------- data ---------- */
  function fetchProduct(p) {
    var base = 'https://judge.me/reviews/reviews_for_widget';
    var url = base + '?url=' + encodeURIComponent(cfg.shopDomain) +
      '&shop_domain=' + encodeURIComponent(cfg.shopDomain) +
      '&platform=shopify&page=1&per_page=100&product_id=' + encodeURIComponent(p.id);
    return fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.reviews) return [];
        return j.reviews.map(function (r) {
          return {
            productId: String(p.id),
            rating: r.rating,
            title: (r.title || '').trim(),
            body: toText(r.body_html),
            nameRaw: (r.reviewer_name || '').trim(),
            isAnon: !!r.is_anonymous_reviewer,
            date: r.created_at,
            verified: !!r.verified_buyer,
            pictures: (r.pictures_urls || []).map(function (pic) { return pic.compact || pic.huge || pic.original; }).filter(Boolean),
            reply: toText(r.reply_content),
            replyName: r.shop_reply_name || cfg.shopName
          };
        });
      })
      .catch(function () { return []; });
  }

  function loadAll() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        if (cached && Date.now() - cached.t < CACHE_MS && cached.d) return Promise.resolve(cached.d);
      }
    } catch (e) {}
    return Promise.all(cfg.products.map(fetchProduct)).then(function (lists) {
      var all = [].concat.apply([], lists);
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: all })); } catch (e) {}
      return all;
    });
  }

  /* ---------- filtering ---------- */
  // Der Kategorie-Filter ist die erste Stufe. Summary, Histogramm und die
  // Sterne-Zaehler haengen alle an DIESEM Satz, nicht an allen Bewertungen —
  // sonst nennt die Seite unter "Shop-Bewertungen" weiter die Gesamtzahlen.
  function pool() {
    if (state.cat === 'shop') return reviews.filter(function (r) { return r.isShop; });
    if (state.cat === 'product') return reviews.filter(function (r) { return !r.isShop; });
    return reviews;
  }

  function countInPool(list, star) {
    if (star === 'all') return list.length;
    return list.filter(function (r) { return Math.round(r.rating) === Number(star); }).length;
  }

  function visible() {
    return pool().filter(function (r) {
      return state.star === 'all' || Math.round(r.rating) === Number(state.star);
    }).sort(function (a, b) {
      if (state.sort === 'highest') return b.rating - a.rating || new Date(b.date) - new Date(a.date);
      if (state.sort === 'lowest') return a.rating - b.rating || new Date(b.date) - new Date(a.date);
      return new Date(b.date) - new Date(a.date);
    });
  }

  /* ---------- rendering ---------- */
  function card(r) {
    var top = el('div', { class: 'tos-crv__card-top' }, [
      stars(r.rating),
      el('span', { class: 'tos-crv__date', text: formatDate(r.date) })
    ]);

    var kids = [top];
    if (r.title) kids.push(el('h3', { class: 'tos-crv__card-title', text: r.title }));
    if (r.body) kids.push(el('p', { class: 'tos-crv__body', text: r.body }));

    if (r.pictures.length) {
      var pics = el('div', { class: 'tos-crv__pics' });
      r.pictures.slice(0, 4).forEach(function (src) {
        pics.appendChild(el('img', { class: 'tos-crv__pic', src: src, alt: '', loading: 'lazy' }));
      });
      kids.push(pics);
    }

    if (r.reply) {
      kids.push(el('div', { class: 'tos-crv__reply' }, [
        el('span', { class: 'tos-crv__reply-name', text: (S.replyFrom || 'Antwort von') + ' ' + (r.replyName || '') }),
        el('span', { text: r.reply })
      ]));
    }

    var author = el('div', { class: 'tos-crv__author' }, [
      el('span', { class: 'tos-crv__author-name', text: displayName(r) })
    ]);
    if (r.verified) {
      var check = el('span', { class: 'tos-crv__verified' });
      check.appendChild(document.createTextNode(S.verified || 'Verifiziert'));
      author.appendChild(check);
    }
    kids.push(author);

    return el('article', { class: 'tos-crv__card' }, kids);
  }

  function avgOf(items) {
    if (!items.length) return 0;
    return items.reduce(function (s, r) { return s + r.rating; }, 0) / items.length;
  }

  function headSub(count, avg) {
    return el('div', { class: 'tos-crv__group-sub' }, [
      stars(avg),
      el('span', { text: avg.toFixed(1).replace('.', cfg.locale === 'de' ? ',' : '.') + ' · ' + count + ' ' + (count === 1 ? (S.reviewOne || 'Bewertung') : (S.reviewMany || 'Bewertungen')) })
    ]);
  }

  function groupHead(p, count, avg) {
    var meta = el('div', { class: 'tos-crv__group-meta' }, [
      el('a', { class: 'tos-crv__group-title', href: p.url, text: p.title }),
      headSub(count, avg)
    ]);
    var kids = [];
    if (p.image) kids.push(el('img', { class: 'tos-crv__group-img', src: p.image, alt: '', loading: 'lazy' }));
    kids.push(meta);
    return el('div', { class: 'tos-crv__group-head' }, kids);
  }

  // Kopf der beiden Sammel-Bloecke. Kein Produktbild, kein Link: Shop-
  // Bewertungen haben keins, und der Produktblock fasst viele Produkte.
  function blockHead(label, count, avg) {
    return el('div', { class: 'tos-crv__group-head tos-crv__group-head--plain' }, [
      el('div', { class: 'tos-crv__group-meta' }, [
        el('h2', { class: 'tos-crv__group-title', text: label }),
        headSub(count, avg)
      ])
    ]);
  }

  function block(label, items) {
    var grid = el('div', { class: 'tos-crv__list' });
    items.forEach(function (r) { grid.appendChild(card(r)); });
    return el('section', { class: 'tos-crv__group' }, [blockHead(label, items.length, avgOf(items)), grid]);
  }

  function render() {
    var out = root.querySelector('[data-crv-results]');
    out.innerHTML = '';
    renderSummary();
    var list = visible();

    if (!list.length) {
      out.appendChild(el('p', { class: 'tos-crv__state', text: S.noMatch || 'Keine Bewertungen für diese Auswahl.' }));
      updateCounts();
      return;
    }

    // Produktbewertungen zuerst, immer nach Produkt geclustert. Die Reihenfolge
    // der Cluster folgt cfg.products, also derselben Reihenfolge wie im SSR.
    var byProduct = {};
    list.forEach(function (r) { if (!r.isShop) (byProduct[r.productId] = byProduct[r.productId] || []).push(r); });
    cfg.products.forEach(function (p) {
      var items = byProduct[String(p.id)];
      if (!items || !items.length) return;
      var grid = el('div', { class: 'tos-crv__list' });
      items.forEach(function (r) { grid.appendChild(card(r)); });
      out.appendChild(el('section', { class: 'tos-crv__group' }, [groupHead(p, items.length, avgOf(items)), grid]));
    });

    // Shop-Bewertungen als letzter Block. Ein Block, den die aktiven Filter
    // leer lassen, entfaellt samt Kopf.
    var shopItems = list.filter(function (r) { return r.isShop; });
    if (shopItems.length) out.appendChild(block(S.shopHead || 'Shop-Bewertungen', shopItems));

    updateCounts();
  }

  function updateCounts() {
    var list = pool();
    // Die Histogramm-Zeilen tragen dasselbe data-Attribut, sind aber keine
    // Pillen: sie haben keinen Zaehler-Slot und keinen Aktiv-Zustand.
    root.querySelectorAll('[data-crv-star]').forEach(function (btn) {
      if (btn.classList.contains('tos-crv__hist-row')) return;
      var v = btn.getAttribute('data-crv-star');
      var n = countInPool(list, v);
      var slot = btn.querySelector('.tos-crv__pill-count');
      if (slot) slot.textContent = n;
      btn.setAttribute('aria-pressed', String(state.star === v));
      btn.disabled = n === 0 && v !== 'all';
    });
    root.querySelectorAll('[data-crv-cat]').forEach(function (btn) {
      var v = btn.getAttribute('data-crv-cat');
      var n = v === 'shop' ? reviews.filter(function (r) { return r.isShop; }).length
        : v === 'product' ? reviews.filter(function (r) { return !r.isShop; }).length
        : reviews.length;
      var slot = btn.querySelector('.tos-crv__pill-count');
      if (slot) slot.textContent = n;
      btn.setAttribute('aria-pressed', String(state.cat === v));
      btn.disabled = n === 0 && v !== 'all';
    });
  }

  function renderSummary() {
    var box = root.querySelector('[data-crv-summary]');
    if (!box) return;
    // Score, Anzahl und Histogramm zeigen die GEWAEHLTE Kategorie, nicht immer
    // alles. Der Sterne-Filter bleibt hier bewusst aussen vor, sonst wuerde das
    // Histogramm nach einem Klick nur noch die eine gewaehlte Zeile kennen.
    var list = pool();
    var total = list.length;
    if (!total) { box.hidden = true; return; }
    var avg = list.reduce(function (s, r) { return s + r.rating; }, 0) / total;
    box.querySelector('[data-crv-avg]').textContent = avg.toFixed(1).replace('.', cfg.locale === 'de' ? ',' : '.');
    var starBox = box.querySelector('[data-crv-avg-stars]');
    starBox.innerHTML = '';
    starBox.appendChild(stars(avg));
    // Die Judge.me-Karte oben kann abweichen: sie nennt die von Judge.me
    // gefuehrte Shop-Gesamtzahl, diese Zahl zaehlt, was die Seite wirklich hat.
    box.querySelector('[data-crv-total]').textContent = total + ' ' + (S.productReviews || 'verifizierte Bewertungen');

    var hist = box.querySelector('[data-crv-histogram]');
    hist.innerHTML = '';
    [5, 4, 3, 2, 1].forEach(function (n) {
      var count = countInPool(list, String(n));
      var pct = total ? Math.round((count / total) * 100) : 0;
      var row = el('button', {
        class: 'tos-crv__hist-row',
        type: 'button',
        'data-crv-star': String(n),
        'aria-label': n + ' ' + (S.starsWord || 'Sterne') + ': ' + count
      }, [
        el('span', { class: 'tos-crv__hist-label', html: n + ' ' + STAR_SVG }),
        el('span', { class: 'tos-crv__hist-track' }, [el('span', { class: 'tos-crv__hist-fill', style: 'width:' + pct + '%' })]),
        el('span', { class: 'tos-crv__hist-count', text: String(count) })
      ]);
      row.addEventListener('click', function () {
        state.star = state.star === String(n) ? 'all' : String(n);
        render();
      });
      hist.appendChild(row);
    });
    box.hidden = false;
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var starBtn = e.target.closest('[data-crv-star]');
    if (starBtn && !starBtn.classList.contains('tos-crv__hist-row')) {
      state.star = starBtn.getAttribute('data-crv-star');
      render();
      return;
    }
    var catBtn = e.target.closest('[data-crv-cat]');
    if (catBtn) {
      state.cat = catBtn.getAttribute('data-crv-cat');
      // Ein Sterne-Filter, den die neue Kategorie nicht bedienen kann, waere
      // eine Sackgasse: die Seite zeigte nur noch "keine Bewertungen".
      if (state.star !== 'all' && countInPool(pool(), state.star) === 0) state.star = 'all';
      render();
    }
  });

  var sortSel = root.querySelector('[data-crv-sort]');
  if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; render(); });

  /* ---------- boot ---------- */
  if (!cfg.products.length && !shopReviews.length) {
    root.querySelector('[data-crv-results]').innerHTML = '';
    root.querySelector('[data-crv-results]').appendChild(
      el('p', { class: 'tos-crv__state', text: S.empty || 'Noch keine Bewertungen.' })
    );
    return;
  }

  loadAll().then(function (data) {
    // Shop-Bewertungen aus dem Liquid + Produktbewertungen aus der API. Erst ab
    // hier decken Filter, Sortierung, Summary und Histogramm beide Quellen ab.
    reviews = shopReviews.concat(data || []);
    root.querySelector('[data-crv-loading]').hidden = true;
    if (!reviews.length) {
      root.querySelector('[data-crv-results]').appendChild(
        el('p', { class: 'tos-crv__state', text: S.empty || 'Noch keine Bewertungen.' })
      );
      return;
    }
    root.querySelector('[data-crv-controls]').hidden = false;
    render();
  });
})();
